<script>
import CalendarView from '@/views/ExtendableBases/CalendarView'

export default {
  extends: CalendarView,
  props: {
    instance: {
      type: Object,
      required: false
    }
  },
  computed: {
    minDate() {
      return this.isInactive ? new Date(2100, 1, 1) : new Date()
    },
    isInactive() {
      return this.instance && !this.instance.is_active
    }
  }
}
</script>
